<template>
    <div class="artist-card-review">
        <div class="image-content">
            <img
                @click="goToShowArtist(artistInfo.slug)"
                :src="fixDoubleSlashes(artistInfo.avatar)"
                class="artist-photo"
            />
        </div>
        <div class="artist-card-content">
            <div class="header-info">
                <div class="header-content">
                    <div class="title-card-info">
                        <a
                            :href="'/artists/' + artistInfo.slug"
                            target="_blank"
                            class="artist-name me-4"
                            >{{ artistInfo.band_name }}</a
                        >
                    </div>
                    <div class="location-container">
                        <div v-if="artistInfo.social_stats" class="social-container">
                            <div class="social-network">
                                <div
                                    v-if="artistInfo.social_stats.instagramStat"
                                    class="social-information"
                                >
                                    <img :src="getIcon + 'inst-social.png'" />
                                    <p class="social-title">
                                        {{
                                            artistInfo.social_stats.instagramStat[0].followers
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="artistInfo.social_stats.facebookStat"
                                    class="social-information"
                                >
                                    <img :src="getIcon + 'spotify-icon.png'" />
                                    <p class="social-title">
                                        {{ artistInfo.social_stats.facebookStat[0].followers }}
                                    </p>
                                </div>
                                <div
                                    v-if="artistInfo.social_stats.twitterStat"
                                    class="social-information"
                                >
                                    <img :src="getIcon + 'cloud-icon.png'" />
                                    <p class="social-title">
                                        {{ artistInfo.social_stats.twitterStat[0].followers }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <p v-if="artistInfo.location" class="location-info">
                            Based in {{ artistInfo.location }}
                        </p>
                    </div>
                    <div class="budget-content">
                        <div class="event-tags" v-if="artistInfo.genre">
                            <p
                                v-for="(vibe, index) in artistInfo.genre
                                    .split(',')
                                    .slice(0, 3)"
                                :key="index"
                                class="event-tag"
                            >
                                {{ vibe }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="artistInfo.description">
                <p class="description-offer" :class="{ 'show-description': readMore }">
                    {{ artistInfo.description }}
                </p>
                <p
                    v-if="artistInfo.description.split('').length > 240"
                    class="read-more"
                    @click="readMore = !readMore"
                >
                    {{ !readMore ? 'Read More' : 'Show less' }}
                </p>
            </div>
            <hr style="background: rgb(139, 139, 139); margin: 0" />
            <div v-if="artistInfo.music" class="music-container">
                <div
                    class="player sound-content"
                    v-for="(audio, index) in artistInfo.music.slice(0, 3)"
                    :key="index"
                >
                    <div class="js-audios-container" @mouseenter="onAudioEnter">
                        <div
                            class="artist-audio custom-audio-element d-flex align-items-center justify-content-evenly"
                            :data-audio-idx="audio.id"
                        >
                            <audio hidden class="d-none" :data-audio-idx="audio.id">
                                <source :src="audio.url" type="audio/mp3" />
                            </audio>
                            <div class="position-relative">
                                <img
                                    :src="getIcon + 'play-button.png'"
                                    class="btn-profile-sound js-profile-btn play js-play-audio play-image"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <p v-if="audio.title" class="song-name">
                            {{ audio.title.slice(0, 15) }}
                        </p>
                        <p class="song-name">- {{ audio.duration }}</p>
                    </div>
                </div>
            </div>
            <hr style="background: rgb(139, 139, 139); margin: 0" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ArtistCard',
        props: {
            artistInfo: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => ({
            readMore: false
        }),
        methods: {
            goToShowArtist(slug) {
                if (slug) {
                    window.location.href = '/artists/' + slug
                } else {
                    return
                }
            },
            onAudioEnter() {
                window.__initAudioElements()
                window.__pauseOtherAudios()
            },
            fixDoubleSlashes(path) {
                return path.replace(/([^:]\/)\/+/g, '$1')
            }
        },
        computed: {
            getIcon() {
                return '/images/'
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../sass/_variables.scss';
    .social-img {
        max-height: 18px;
        max-width: 18px;
    }
    .artist-name {
        margin: 0;
        text-decoration: none;
        color: #acacac;
        max-width: 100%;
        overflow: hidden;
    }
    .title-card-info {
        color: #dedede;
        font-size: 44px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
        align-items: center;
        display: flex;
    }
    .show-description {
        max-height: 85px !important;
        overflow-y: scroll !important;
    }
    .show-description::-webkit-scrollbar {
        width: 0;
    }
    .read-more {
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        cursor: pointer;
    }
    .image-content {
        display: flex;
    }
    .favorite-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        padding: 8px 20px;
    }
    .favorite-container p {
        color: #cdeb09;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .favorite-container img {
        max-width: 18px;
    }
    .music-container::-webkit-scrollbar {
        width: 0;
    }
    .music-container {
        display: flex;
        align-items: flex-start;
        gap: 24px;
        overflow-x: scroll;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .play-image {
        min-width: 30px;
        min-height: 30px;
    }
    .budget-content {
        display: flex;
        align-items: center;
        gap: 24px;
    }
    .header-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
    .event-tags {
        display: flex;
        flex-direction: row;
        gap: 5px;
        margin-top: 5px;
        min-height: 26px;
    }
    .event-tags::-webkit-scrollbar {
        width: 0;
    }
    .event-tag {
        border: 1px solid #8b8b8b;
        border-radius: 100px;
        color: #8b8b8b;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        letter-spacing: 0.12px;
        line-height: 135%;
        padding: 3px 10px 4px;
        max-width: 100px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin: 0;
    }
    .save-to-contact {
        padding: 7px 20px 10px 20px;
        border-radius: 100px;
        border: 1px solid #cdeb09;
        background: #262626;
        color: #cdeb09;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .location-container {
        display: flex;
        align-items: center;
        gap: 24px;
    }
    .social-network {
        display: flex;
        align-items: center;
        gap: 20px;
    }
    .btn-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    .min-rate-artist {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.96px;
    }
    .min-rate-artist span {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 110%;
        letter-spacing: -1.28px;
    }
    .artist-photo {
        min-height: 318px;
        max-width: 300px;
        object-fit: cover;
        border-radius: 15px 0 0 15px;
        cursor: pointer;
    }
    .song-name {
        color: #acacac;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .social-information img {
        max-width: 22px;
        max-height: 22px;
    }
    .social-information p {
        color: #dedede;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .social-container {
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }
    .social-information {
        display: flex;
        gap: 6px;
    }
    .location-info {
        color: #acacac;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
        margin: 0;
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .description-offer {
        overflow: hidden;
        color: #acacac;
        text-overflow: ellipsis;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        max-width: 95%;
        max-height: 42px;
        white-space: pre-line;
        margin: 0;
    }
    .artist-card-review {
        display: flex;
        border-radius: 15px;
        background: #262626;
        max-height: 390px;
        width: 60%;
    }
    .artist-card-content {
        flex: 0 1 80%;
        padding: 20px 25px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-width: calc(100% - 320px);
    }
    .sound-content {
        display: flex;
        align-items: center;
        gap: 6px;
    }
    .top-city p {
        color: #acacac;
        font-size: 18px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .pills-info p {
        border-radius: 100px;
        border: 1px solid #acacac;
        color: #acacac;
        font-size: 12px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        padding: 3px 10px 4px 10px;
    }
    .go-back-to-all {
        border-radius: 100px;
        background: #c9cd00;
        color: #262626;
        font-size: 18px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        border: 0;
        max-height: 45px;
        padding: 7px 20px 10px 20px;
    }
    .header-info {
        display: flex;
        justify-content: space-between;
    }
    @media (max-width: 2560px) {
        .artist-card-review {
            width: 60%;
        }
    }
    @media (max-width: 1440px) {
        .artist-card-content {
            max-width: 60%;
        }
    }
    @media (max-width: 1050px) {
        .artist-name {
            text-decoration: none;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 240px;
            white-space: nowrap;
        }
        .header-content {
            max-width: 300px;
        }
        .description-container {
            text-decoration: none;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 400px;
            white-space: nowrap;
        }
        .music-container {
            max-width: 400px;
        }
        .artist-card-review {
            max-height: 390px;
            width: 80%;
        }
        .event-tags {
            overflow-y: scroll;
            max-width: 300px;
        }
        .min-rate-artist {
            max-width: 110px;
        }
        .go-back-to-all {
            padding: 5px 30px;
        }
    }
    @media (max-width: 1000px) {
        .artist-card-review {
            flex-direction: column;
            max-height: none;
            width: 100%;
            max-width: 600px;
        }
        .budget-content {
            flex-direction: column;
        }
        .header-info {
            flex-direction: column;
        }
        .artist-photo {
            border-radius: 15px 15px 0 0;
            max-width: 100%;
        }
        .artist-card-content {
            flex: initial;
            max-width: initial;
            padding: 16px;
        }
        .title-card-info {
            color: #acacac;
            font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on,
                'ss03' on;
            font-family: Instrument Sans;
            font-size: 20px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
            letter-spacing: -0.2px;
        }
        .location-container {
            gap: 12px;
            flex-direction: column-reverse;
            align-items: flex-start;
        }
        .image-content {
            position: relative;
        }
        .favorite-container {
            position: absolute;
            bottom: 0;
            left: 20%;
        }
        .btn-container {
            flex-direction: row;
            gap: 8px;
        }
        .go-back-to-all {
            font-size: 15px;
            padding: 7px 20px 10px 20px;
        }
        .event-tag {
            margin: 0;
        }
        .save-to-contact {
            font-size: 15px;
        }
        .read-more {
            margin: 0;
        }
    }
</style>
